import Layers from "slotworks/graphics/layers/layers";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";

export default class DisabledPromoButtonBehaviour extends AbstractButtonBehaviour {

    public init() {
        Layers.SmartButton.setScene("promo").execute();
        this.button = Layers.SmartButton.getFlexiButton("spin_promo");
        this.button.setEnabled(false);

        let label = Layers.SmartButton.getFlexiText("label-stop");
        let spinlabel = Layers.SmartButton.getFlexiText("label-spin");
        label.setVisible(false);
        spinlabel.setVisible(true);
    }

    public destroy() {
        super.destroy();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/promo-fs-disabled-button-behaviour.ts